import {HTTP, ERROR} from '@/http-common';
import Router from '@/router';
import Vue from 'vue';
import moment from "moment";

import {clearUserData} from "../../http-common";

const state = {
  authenticated: false,
  confirmation: false,
  user: localStorage.getItem('user_account') && JSON.parse(localStorage.getItem('user_account')) ||  null,
  activityFeed: {
    page: 1,
    pages: 1,
    loading: false
  },
  editNote: {
    loading: false,
  },
  loginError: '',
  viewAsUsers: [],
  viewAsUsersLoading: false,
  allNotes: [],
  confirmationError: true,
  confirmationMessage: '',
  currentOrganization: JSON.parse(localStorage.getItem('user_current_organization')),
  sessionEndDate: null,
  isSessionUpdatePending: false
};

const mutations = {
  SET_SESSION_END_DATE(state, date){
    state.sessionEndDate = date
  },
  SET_IS_SESSION_UPDATE_PENDING(state, flag){
    state.isSessionUpdatePending = flag
  },
  SET_USER(state, data) {
    if (data.time_zone == null) {
      data['time_zone'] = 'Etc/GMT-0';
    }

    if (data.date_format == null) {
      data['date_format'] = 'MM/DD/YYYY'
    }

    clearUserData();
    localStorage.setItem('user_account', JSON.stringify(data));

    let organization = {};

    if (data.hasOwnProperty('organizations') && data.organizations.length) {
      organization = data.organizations[0];
    }

    state.currentOrganization = organization;
    localStorage.setItem('user_current_organization', JSON.stringify(organization));

    state.user = data;
  },
  UPDATE_USER_MAINTENANCE(state, maintenance) {
    state.user.maintenance_mode = maintenance;
  },
  SET_USER_VALUE(state, payload) {
    Object.keys(payload).forEach(obj => {
      state.user[obj] = payload[obj];
    });
  },
  SET_ACTIVITY_FEED(state, data) {
    state.activityFeed = data;
    state.activityFeed.loading = false;
  },
  SET_EDIT_NOTE(state, data) {
    state.editNote = data;
    state.editNote.loading = false;
  },
  SET_ALL_NOTES(state, data) {
    state.allNotes = data;
  },
  SET_VIEW_AS_USERS(state, data) {
    state.viewAsUsers = data;
  },
  SET_VIEW_AS_USERS_LOADING(state, data) {
    state.viewAsUsersLoading = data;
  },
  LOCK_USER() {
    localStorage.removeItem('id_token');
    Router.push('/lock');
  }
};

const getters = {
  sessionEndDate: state => state.sessionEndDate,
  isSessionUpdatePending: state => state.isSessionUpdatePending,
  getUser: state => {
    return state.user;
  },
  getAllNotes: state => state.allNotes,
  getConfirmation: state => state.confirmation,
  getActivity: state => state.activityFeed,
  getLoginError: state => state.loginError,
  getEditNote: state => state.editNote,
  getViewAsUsers: state => state.viewAsUsers,
  getViewAsUsersLoading: state => state.viewAsUsersLoading,
  getConfirmationError: state => state.confirmationError,
  getConfirmationMessage: state => state.confirmationMessage,
  getOrganization: state => state.currentOrganization,
};

const actions = {
  lockUser: ({commit}) => {
    commit('LOCK_USER');
  },
  checkAuth: ({commit, dispatch, state}) => {
    HTTP.post(`users/check`, localStorage.getItem('id_token'))
      .then(response => {
        if (response.data.status == 'error') {
          commit('LOCK_USER');
        }

        // sets session end date in current timezone time
        const currentDate = moment(response.data.data.current_date.date);
        const expiryDate = moment(response.data.data.expired_time.date);
        const diffInSeconds = expiryDate.diff(currentDate) / 1000;
        if (diffInSeconds > 0){
          const expirationDateInCurrentTimezone = moment().add(diffInSeconds, 'seconds');
          commit('SET_SESSION_END_DATE', expirationDateInCurrentTimezone.format());
          commit('SET_IS_SESSION_UPDATE_PENDING', false);
        }

        if (
          response.data.status == 'success' && (state.user.alerts && (response.data.data.alerts.count != state.user.alerts.count))
        ) {
          dispatch('GET_USER_DATA_REFRESH_ACTION');
        } else {
          commit('UPDATE_USER_MAINTENANCE', response.data.data.maintenance_mode);
        }
      }).catch(err => {
      console.log(err);
    });
  },
  setUserValue: ({commit}, payload) => {
    commit('SET_USER_VALUE', payload);
  },
  LOGIN_ACTION: ({commit}, payload) => {
    payload.context.start();
    state.loginError = '';
    state.confirmation = false;
    return HTTP.post(`users/auth`, payload.credentials)
      .then((response) => {
        ERROR(response);

        if (response.data.status == 'success') {

          if (response.data.data && response.data.data.redirect_to_two_factor == true) {

            localStorage.setItem('casemgr-2fa-email', response.data.data.email);
            localStorage.setItem('casemgr-2fa-token', response.data.data.token);

              Router.push('/login-two-factor');
              return response;
          }

          if (response.data.data['confirmation_token'] != null) {
            Router.push({name: 'New Password', params: {token: response.data.data['confirmation_token']}});
            return false;
          }

          localStorage.setItem('id_token', response.data.data.token);
          commit('SET_USER', response.data.data);
          HTTP.defaults.headers = {
            Token: response.data.data.token
          };
          state.authenticated = true;
          Router.push('/admin/dashboard');
        }

        if (response.data.status == 'error') {
          state.loginError = response.data.message;
          if (payload.callback != null)
            payload.callback();
          if (payload.notify) {
            Vue.prototype.$notify({
              type: 'error',
              text: response.data.message
            });
          }
        }
        payload.context.stop();
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    });
  },
  SEND_AGAIN_TWO_FACTOR_CODE_ACTION: ({commit}, payload) => {
    return HTTP.post('users/resend-auth-code', {
      token: payload.token
    }).then((response) => {
      ERROR(response);

      if (response.data.status === 'success') {
        if (response.data.data && response.data.data.redirect_to_two_factor) {
          localStorage.setItem('casemgr-2fa-token', response.data.data.token);
          return response;
        }
      }

      if (response.data.status === 'error') {
        state.loginError = response.data.message;
        if (payload.callback != null)
          payload.callback();
        if (payload.notify) {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      }
      payload.context.stop();
    }).catch(err => {
      payload.context.stop();
      console.log(err);
    });
  },

  LOGIN_TWO_FACTOR_ACTION: ({commit}, payload) => {
    return HTTP.post('users/auth-code', {
      code: payload.code,
      token: payload.token
    }).then((response) => {
        ERROR(response);

        if (response.data.status === 'success') {

          if (response.data.data && response.data.data.redirect_to_two_factor) {
            localStorage.setItem('casemgr-2fa-token', response.data.data.token);
            Router.push('/login-two-factor');
            return response;
          }

          localStorage.removeItem('casemgr-2fa-token');
          localStorage.setItem('id_token', response.data.data.token);

          commit('SET_USER', response.data.data);

          HTTP.defaults.headers = {
            Token: response.data.data.token
          };

          state.authenticated = true;
          Router.push('/admin/dashboard');
        }

        if (response.data.status === 'error') {
          state.loginError = response.data.message;
          if (payload.callback != null)
            payload.callback();
          if (payload.notify) {
            Vue.prototype.$notify({
              type: 'error',
              text: response.data.message
            });
          }
        }
        payload.context.stop();
      }).catch(err => {
        payload.context.stop();
        console.log(err);
      });
  },

  FORGOT_PASSWORD_ACTION: ({commit}, payload) => {
    payload.context.start();
    HTTP.post(`resetting/email`, {email: payload.email})
      .then(response => {
        ERROR(response);

        payload._self.remindPassword = false;
        payload._self.showLogin = true;
        payload._self.forgotEmail = '';

        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
        }
        else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        payload.context.stop();
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    });
  },
  CHANGE_PASSWORD_ACTION: ({commit}, payload) => {
    let data;
    payload.context.start();
    if (payload.oldPass != null) {
      data = {
        token: payload.token,
        oldPass: payload.oldPass,
        password: payload.password
      }
    } else {
      data = {
        token: payload.token,
        password: payload.password
      }
    }
    HTTP.post(`resetting/change`, data)
      .then(response => {
        ERROR(response);
        if (response.data.status === 'success') {
          Vue.prototype.$notify(response.data.data.message);
          Router.push('/login');
        }
        if (response.data.status === 'error') {
            state.confirmationError = false;
            if (response.data.message === 'Your password must be different than your current password.'){
              state.confirmationMessage = 'Your password must be different than your current password.';
            }
            else if (response.data.message === 'Confirmation token expired.'){
              state.confirmationMessage = 'The forgot password link is either incorrect or no longer valid..';
            }
            else {
              state.confirmationMessage = 'The password entered does not meet password requirements.';
            }
        }
        payload.context.stop();
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    });
  },
  CHECK_CONFIRMATION_TOKEN_ACTION: ({commit}, payload) => {
    payload.context.start();
    HTTP.post(`confirmation`, {token: payload.token, password: payload.password})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'error') {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        } else {
          state.confirmation = true;
          Router.push('/login');
        }
        payload.context.stop();
      }).catch(err => {
      payload.context.stop();
      console.log(err);
    });
  },
  CHECK_VALID_TOKEN_ACTION: ({commit}, payload) => {
    HTTP.post(`confirmation/check`, {token: payload.token})
      .then(response => {
        ERROR(response);
        if (response.data.status == 'error') {
          if (payload.remind) {
            state.confirmationMessage = 'The forgot password link is either incorrect or no longer valid.';
          } else {
            state.confirmationMessage = response.data.message;
          }
        } else {
          state.confirmationError = false;
        }
      }).catch(err => {
      state.confirmationError = true;
      console.log(err);
    });
  },
  GET_WIDGET_ACTIVITY_FEED_ACTION: ({commit}, payload) => {
    state.activityFeed.loading = true;
    HTTP.post(`/activities`, {page: payload.page, from: payload.from, to: payload.to})
      .then((response) => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_ACTIVITY_FEED', response.data.data);
        }
      })
      .catch(err => {
        state.activityFeed.loading = false;
        console.log(err);
      });
  },
  ADD_CASE_NOTE_ACTION: ({commit, dispatch}, payload) => {
    HTTP.post(`/notes/create`, {type: payload.type, note: payload.note, participant: payload.id})
      .then((response) => {
        ERROR(response);
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
          payload._this.caseNote = '';
          payload._this.caseNoteType = 'collateral';
          dispatch('loadParticipant', payload.id);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  GET_CASE_NOTE_ACTION: ({commit}, payload) => {
    return HTTP.post(`/notes`, payload)
      .then((response) => {
        ERROR(response);
        commit('SET_ALL_NOTES', response.data.data);
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  EDIT_CASE_NOTE: ({commit}, payload) => {
    commit('SET_EDIT_NOTE', payload);
  },
  EDIT_CASE_NOTE_ACTION: ({commit, dispatch}, payload) => {
    payload.start();
    HTTP.post(`/notes/edit/${state.editNote.id}`, {type: state.editNote.type, note: state.editNote.note})
      .then((response) => {
        ERROR(response);
        if (response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data.message);
          payload.stop();
          $('#edit-case-notes').modal('hide');
          dispatch('loadParticipant', Router.currentRoute.params.id);
        }
      })
      .catch(err => {
        payload.stop();
        console.log(err);
      });
  },
  ADD_TO_FAVORITE_NOTE: ({commit, dispatch}, payload) => {
    HTTP.post(`/notes/pin/${payload.id}`,{status:payload.status})
    .then((response) => {
      ERROR(response);
      if (response.data.status == 'success') {
      Vue.prototype.$notify(response.data.data.message);
        // payload.stop();
        dispatch('loadParticipant', Router.currentRoute.params.id);
      }
    })
    .catch(err => {
      console.log(err);
    });
  },
  GET_USERS_LIST: ({commit}, payload) => {
    commit('SET_VIEW_AS_USERS_LOADING', true);
    HTTP.post(`accounts/view`)
      .then((response) => {
        ERROR(response);
        if (response.data.status === 'success') {
          commit('SET_VIEW_AS_USERS', response.data.data.data);
        }
      })
      .catch(err => {
        payload.stop();
        console.log(err);
      }).finally(() => {
          commit('SET_VIEW_AS_USERS_LOADING', false);
      });
  },
  SET_DEFAULT_ACCOUNT_ACTION: ({commit, dispatch}, payload) => {
    Vue.prototype.$notify({
      type: 'warning',
      text: 'Re-logging...'
    });
    HTTP.post(`accounts/default`, {account_id: payload})
      .then((response) => {
        ERROR(response);
        if (response.data.status === 'error') {
          Vue.prototype.$notify(response.data.data.message);
        }
        if (response.data.status === 'success') {
          dispatch('GET_USER_DATA_ACTION', true);
          dispatch('GET_USERS_LIST');
          // clear cached account list and modules
          dispatch('resetUserAccounts');
          dispatch('fetchModules', {force: true})
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  GET_USER_DATA_ACTION: ({commit}, payload) => {
    HTTP.post(`users/data`)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_USER', response.data.data);
          Vue.prototype.$notify({
            type: 'success',
            text: 'Account updated.'
          });
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      }).catch(err => {
      console.log(err);
    });
  },
  GET_USER_DATA_REFRESH_ACTION: ({commit}, payload) => {
    return HTTP.post(`users/data`)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_USER', response.data.data);
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      }).catch(err => {
      console.log(err);
    });
  },
  setIsSessionUpdatePending: ({commit}, flag) => {
    commit('SET_IS_SESSION_UPDATE_PENDING', flag);
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js